/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Hero_Pill_MailInputs */



/**
* | output |
* | --- |
* | "Sent 8 summaries to the design team" |
*
* @param {Integrations_Hero_Pill_MailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_hero_pill_mail = /** @type {((inputs?: Integrations_Hero_Pill_MailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Hero_Pill_MailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("8 Zusammenfassungen ans Design-Team gesendet")
	return /** @type {LocalizedString} */ ("Sent 8 summaries to the design team")
});